export const JWTExpiryThreshold = 1800; // Seconds
export const JWTRefreshSWRKey = "refresh-jwt";
